// backend ตอบ 400 พร้อม body "INPUT_TOO_LONG:<limit>" เมื่อข้อความยาวเกิน MaximumChatInput ของโมเดล
// (MSTeamBAL.ValidateChatInputLength) รวมไว้ที่เดียวเพื่อไม่ให้แต่ละหน้าจอ parse เอง
const INPUT_TOO_LONG_PATTERN = /INPUT_TOO_LONG:(\d+)/;

export const DEFAULT_CHAT_INPUT_LIMIT = 200000;

export const isInputTooLongError = (response) => response?.response?.status === 400;

// เพดานที่ backend ส่งมาเป็นค่าจริงจาก DB ส่วน fallback คือค่าที่หน้าจอถืออยู่ (อาจเป็นค่าเก่า)
export const parseServerCharLimit = (response, fallback) => {
  const body = typeof response?.response?.data === 'string' ? response.response.data : '';
  const matched = body.match(INPUT_TOO_LONG_PATTERN);
  return matched ? Number.parseInt(matched[1], 10) : fallback;
};

// MaximumChatInput ที่เป็น null/0/ค่าเพี้ยนใน DB ต้องกลายเป็น default ไม่ให้เพดานหลุดเป็นค่าว่าง
export const normalizeCharacterLimit = (value, fallback = DEFAULT_CHAT_INPUT_LIMIT) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isNaN(parsed) || parsed < 1 ? fallback : parsed;
};
